import { render, staticRenderFns } from "./ClientIncome.vue?vue&type=template&id=3aa696d0"
import script from "./ClientIncome.vue?vue&type=script&lang=js"
export * from "./ClientIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports